var E = /* @__PURE__ */ ((r) => (r.DEFAULT = "default", r.PRIMARY = "primary", r.SECONDARY = "secondary", r.TERTIARY = "tertiary", r.SUCCESS = "success", r.ERROR = "error", r))(E || {}), s = /* @__PURE__ */ ((r) => (r.DEFAULT = "default", r.LARGE = "large", r))(s || {});
export {
  E as RocheUIIconButtonAppearance,
  s as RocheUIIconButtonSize
};
